module.exports = __webpack_public_path__ + "img/baseline-search-24px.6db83280.svg";